/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-plain-object/~/isobject/index.js
 ** module id = 820
 ** module chunks = 0
 **/